import { Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';

import { TourActionButton } from './PdpTourActionButton';

export const PdpAgentTourCard = ({ onCopyLink }: { onCopyLink: () => void }) => (
  <Col
    as="section"
    aria-label="Tour with agent"
    className="hidden w-full gap-5 rounded-[18px] bg-od-bg-tertiary px-6 py-5 min-[1024px]:flex"
  >
    <Col className="gap-2">
      <Text as="h2" className="text-subheader-xs text-od-content-primary">
        Tour with agent
      </Text>
      <Text className="min-h-5 text-label-sm text-od-content-secondary">
        Share with your agent to book a tour
      </Text>
    </Col>
    <TourActionButton
      action={{
        text: 'Share this link',
        onClick: onCopyLink,
        variant: 'secondary',
        analyticsName: 'cosmos-marketplace-pdp-agent-copy-link',
      }}
      label="Share this link"
      variant="secondary"
      className="h-12 px-3 text-label-sm"
    />
  </Col>
);
